module.exports = __webpack_public_path__ + "img/0Q3A2626_L_BlackMatted.badca640.jpg";